<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M2.667 6.666a1 1 0 011-1h24.667a1 1 0 010 2H3.667a1 1 0 01-1-1zm0 9.333a1 1 0 011-1h24.667a1 1 0 010 2H3.667a1 1 0 01-1-1zm1 8.334a1 1 0 100 2h24.667a1 1 0 000-2H3.667z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'symbolsBarsOutline'
}
</script>
